export function isValidPrice(price) {
  return (
    new RegExp(/^\d+(\.\d{1,3})?$/).test(price) &&
    parseFloat(price) < 1000000000 &&
    !String(price || "")?.includes(",")
  );
}
